import {
	ApplicationStateEnum,
	ApplicationStateReasonEnum,
	EshopBrokerSlugEnum,
} from '.spec/self-care/tsTypes';
import { cond, constant, matches, path, pathOr } from 'lodash/fp';

export const getCurrentDebt = path(['financing', 'currentDebt']);
export const getEshopName = pathOr('', ['eshopAdditionalInfo', 'name']);
export const getOrderItems = path(['order', 'items']);
export const getPromocodes = path(['order', 'promocodeDiscounts']);

export const VirtualApplicationStatusEnum = {
	CANCELED: 'CANCELED',
	EXPIRED: 'EXPIRED',
	PAID: 'PAID',
	REJECTED: 'REJECTED',
	RETURNED: 'RETURNED',
	UNFINISHED: 'UNFINISHED',
	UNPAID: 'UNPAID',
	WAITING: 'WAITING',
};

export const getVirtualApplicationStatus = cond([
	[
		(application) =>
			application.state === ApplicationStateEnum.READY &&
			application.financing?.currentDebt.amount <= 0,
		constant(VirtualApplicationStatusEnum.PAID),
	],
	[
		(application) =>
			application.state === ApplicationStateEnum.READY &&
			!application.financing?.deferredPayment?.dueDate,
		constant(VirtualApplicationStatusEnum.WAITING),
	],
	[
		(application) =>
			application.state === ApplicationStateEnum.READY &&
			application.financing?.currentDebt.amount > 0 &&
			application.financing?.deferredPayment?.currentDpd <= 0,
		constant(VirtualApplicationStatusEnum.UNPAID),
	],
	[
		(application) =>
			application.state === ApplicationStateEnum.READY &&
			application.financing?.currentDebt.amount > 0 &&
			application.financing?.deferredPayment?.currentDpd > 0,
		constant(VirtualApplicationStatusEnum.EXPIRED),
	],
	[
		matches({ state: ApplicationStateEnum.PROCESSING }),
		constant(VirtualApplicationStatusEnum.UNFINISHED),
	],
	[
		matches({ state: ApplicationStateEnum.REJECTED }),
		constant(VirtualApplicationStatusEnum.REJECTED),
	],
	[
		(application) =>
			application.state === ApplicationStateEnum.CANCELLED &&
			application.stateReason !== ApplicationStateReasonEnum.CANCELLED_RETURNED,
		constant(VirtualApplicationStatusEnum.CANCELED),
	],
	[
		(application) =>
			application.state === ApplicationStateEnum.CANCELLED &&
			application.stateReason === ApplicationStateReasonEnum.CANCELLED_RETURNED,
		constant(VirtualApplicationStatusEnum.RETURNED),
	],
]);

export const isComgateOrder = (application) =>
	application.eshopAdditionalInfo.brokerSlug === EshopBrokerSlugEnum.COMGATE;
